import React, { createContext, useContext } from "react";

const AuthContext = createContext({ user: null, refresh: () => {} });

export function AuthProvider({ value, children }) {
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}

export function useIsAdmin() {
  const { user } = useAuth();
  return user?.role === "admin";
}
